module.exports = __webpack_public_path__ + "img/FSc (Medical).7c31b411.svg";